var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"nt-button",class:['nt-button_'+_vm.type,'nt-button_'+_vm.size,{
        'nt-button_disabled':_vm.isDisabled,
        'nt-button_long':_vm.long
    }],attrs:{"disabled":_vm.isDisabled},on:{"click":_vm.handleClick}},[_c('span',{staticClass:"nt-button__icon"}),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }